import React from "react";
import { Link, useNavigate } from "react-router-dom";
import providerRoutes from "../../../utlis/provider/routes.utlis.js";
import { routes } from "../../../utlis/user/routes.utlis";
import Header from "../../common/Header.js";
import Caregiver1 from "../../../assets/images/cg1.webp";
import Caregiver2 from "../../../assets/images/cg2.webp";
import Caregiver3 from "../../../assets/images/cg3.webp";
import Caregiver4 from "../../../assets/images/cg4.webp";
import featurejobs1 from "../../../assets/images/job1.webp";
import featurejobs2 from "../../../assets/images/job2.webp";
import careseekerca from "../../../assets/images/careseeker-CA.webp";
import ProcessImage from "../../../assets/images/Process.webp";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import "pure-react-carousel/dist/react-carousel.es.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Helmet } from "react-helmet-async";
import LocationsGrid from "./LocationsGrid.js";

const PageGeorgia = () => {
  const navigate = useNavigate();

  //Add FAQ Schema
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What caregiving roles are most in demand in Georgia?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Senior care, live-in support, recovery assistance, and in-home care roles are consistently in demand across the state."
        }
      },
      {
        "@type": "Question",
        "name": "Can caregivers choose where they want to work within Georgia?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Caregivers can focus on specific cities or regions, such as metro Atlanta or nearby suburbs, and apply only to roles that fit their travel range and comfort level."
        }
      },
      {
        "@type": "Question",
        "name": "Do Georgia caregivers get paid hourly or weekly?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Payment structures vary by role. Some families offer hourly pay for part-time care, while live-in and long-shift roles often provide weekly or fixed-rate compensation based on responsibilities."
        }
      },
      {
        "@type": "Question",
        "name": "How quickly can a caregiver start working after applying for a job?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Many caregivers begin receiving responses within days, especially when their profile is complete, and availability aligns with family needs. Clear communication often speeds up the hiring process."
        }
      }
    ]
  };

  React.useEffect(() => {
    // inject JSON-LD into head as a fallback to ensure it's present
    const id = "faq-schema-georgia";
    if (!document.getElementById(id)) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = id;
      script.text = JSON.stringify(faqSchema);
      document.head.appendChild(script);
    }
    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, []);

  return (
    <>
      <Helmet
        script={[
          {
            type: "application/ld+json",
            innerHTML: JSON.stringify(faqSchema),
          },
        ]}
      >
        <title>Looking for live-in caregiver job opportunities in Georgia?</title>
        <meta
          name="description"
          content="The flexible, satisfactory, live-in caregiver jobs in Georgia await. Join Care-Exchange and connect with families seeking trusted caregivers today."
        />
        <meta
          name="keywords"
          content="live-in caregiver jobs in georgia, home health care in georgia, home care in atlanta georgia, in-home care atlanta, ga caregiver program, home care agency in georgia"
        />
        {/* Self Canonical */}
        <link
          rel="canonical"
          href="https://care-exchange.com/find-job/GA"
        />
        {/* FAQ Schema injected via Helmet `script` prop */}
      </Helmet>
      <Header></Header>
      <div className="caregiver-hero-section">
        <div className="caregiver-hero-content">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-md-5">
                <div className="caregiver-hero-text">
                  <h1>Find Trusted Live-in Caregiver Jobs in Georgia</h1>

                  <p>
                    Want to boost your caregiver career across cities and
                    suburbs? Care-Exchange helps you access flexible{" "}
                    <b>live-in caregiver jobs in Georgia</b>, from daily
                    assistance to long-term support, while giving you control
                    over your schedule, location, and career growth.
                  </p>
                  <button
                    className="caregiver-hero-btn"
                    style={{ border: "none" }}
                    type="button"
                    onClick={() => {
                      localStorage.setItem(
                        "findJobCare",
                        JSON.stringify({
                          lat: "",
                          lng: "",
                          address: "",
                          state: "",
                        })
                      );
                      navigate(routes.login);
                    }}
                  >
                    Find Jobs
                  </button>
                </div>
              </div>

              <div className="col-md-7">
                <div className="caregiver-hero-media">
                  <div className="caregiver-image-2">
                    <img src={Caregiver2} alt="Find Caregiver Jobs" />
                  </div>

                  <div className="caregiver-image-4">
                    <img src={Caregiver3} alt="Find Caregiver Jobs" />
                  </div>
                  <div className="caregiver-image-1">
                    <img src={Caregiver1} alt="Find Caregiver Jobs" />
                  </div>
                  <div className="caregiver-image-3">
                    <img src={Caregiver4} alt="Find Caregiver Jobs" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="caregiver-service-section">
        <div className="container">
          <div className="row  justify-content-center">
            <div className="col-md-12">
              <div className="caregiver-service-text">
                <h2 className="text-center">
                  Here Georgia Caregivers Meet the Right Opportunities
                </h2>

                <p>
                  Care needs across Georgia are expanding rapidly, particularly
                  in metro areas such as Atlanta and its surrounding
                  communities. Care-Exchange connects caregivers directly with
                  families, seniors, and licensed providers seeking dependable
                  support. Whether you’re exploring{" "}
                  <b>live-in caregiver jobs in Georgia</b>, part-time care
                  roles, or long-term placements, our platform simplifies the
                  process.
                </p>
                <p>
                  You gain access to caregiving opportunities aligned with your
                  skills, experience, and availability without middlemen or
                  unnecessary delays. From <b>home health care in Georgia</b> to
                  personalized in-home support, Care-Exchange empowers
                  caregivers to work confidently while making a lasting
                  difference.
                </p>

                <ul class="caregiver-feature-list">
                  <li>
                    <span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                          fill="#BDFFC0"
                        />
                        <path
                          d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                          stroke="#45B14A"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>{" "}
                    <b>Flexible Work Options –</b> Choose hourly, full-time, or
                    live-in roles
                  </li>
                  <li>
                    <span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                          fill="#BDFFC0"
                        />
                        <path
                          d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                          stroke="#45B14A"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>{" "}
                    <b>Local Opportunities –</b> Jobs across Florida cities and
                    communities
                  </li>
                  <li>
                    <span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                          fill="#BDFFC0"
                        />
                        <path
                          d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                          stroke="#45B14A"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>{" "}
                    <b>Quick Applications –</b> Apply easily using one complete
                    profile
                  </li>
                  <li>
                    <span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                          fill="#BDFFC0"
                        />
                        <path
                          d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                          stroke="#45B14A"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>{" "}
                    <b>Trusted Matches –</b> Families and verified care
                    providers
                  </li>

                  <li>
                    <span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                          fill="#BDFFC0"
                        />
                        <path
                          d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                          stroke="#45B14A"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>{" "}
                    <b>Career Stability –</b> Build reviews and unlock
                    better-paying roles
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="caregiver-section">
        <div className="container">
          <div className="caregiver-heading text-center">
            <h2>Discover your next caregiver job in Georgia, GA</h2>
          </div>

          <div class="row justify-content-center mt-5">
            <div className="col-lg-4 col-md-6">
              <div className="caregiver-feature-card text-center">
                <div className="caregiver-icon-box">
                  <svg
                    width="84"
                    height="84"
                    viewBox="0 0 84 84"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M70.1321 12.3508C69.8274 11.9332 69.4429 11.5802 69.0009 11.3121C68.5589 11.044 68.0681 10.8662 67.5569 10.789L16.9535 3.07147C15.9215 2.91582 14.8699 3.17555 14.029 3.79378C13.1881 4.41201 12.6266 5.33832 12.4674 6.36978L3.95714 62.1615C3.80678 63.1929 4.06857 64.242 4.68584 65.0818C5.30311 65.9216 6.22623 66.4846 7.25545 66.649L48.0506 72.8715C49.8498 73.1469 51.6857 73.065 53.4532 72.6305C55.2207 72.1959 56.8853 71.4172 58.3517 70.3389C59.8181 69.2606 61.0576 67.9039 61.9993 66.3463C62.941 64.7886 63.5665 63.0607 63.8399 61.2612L70.854 15.2764C70.9328 14.7655 70.9096 14.244 70.7857 13.742C70.6618 13.2401 70.4396 12.7677 70.1321 12.3522V12.3508Z"
                      fill="#45B14A"
                    />
                    <path
                      d="M68.8537 75.7965C68.67 75.8096 65.8612 76.1771 61.7662 76.7152C50.0719 78.2509 27.9956 81.1646 27.4181 81.1646C26.4638 81.1621 25.5428 80.8135 24.826 80.1835C24.1092 79.5536 23.6451 78.685 23.52 77.739L16.2356 21.774C16.1092 20.7383 16.3947 19.6944 17.0305 18.8671C17.6663 18.0398 18.6016 17.4953 19.635 17.3509L70.3894 10.749C71.4223 10.6184 72.4651 10.9009 73.2909 11.535C74.1167 12.1691 74.6588 13.1036 74.7994 14.1352L80.0625 54.5209L80.8106 60.2696C81.2808 63.9136 80.2858 67.5953 78.044 70.5064C75.8022 73.4175 72.4969 75.3201 68.8537 75.7965Z"
                      fill="#FFD740"
                    />
                    <path
                      d="M68.8537 75.7971C68.67 75.8102 65.8612 76.1777 61.7662 76.7159C62.3473 74.2511 62.6424 71.7276 62.6456 69.1952C61.1362 62.3177 65.0212 56.1359 72.7519 56.1227C73.6969 55.9915 77.3981 55.2434 80.0625 54.5215L80.8106 60.2702C81.2808 63.9143 80.2858 67.5959 78.044 70.507C75.8022 73.4181 72.4969 75.3207 68.8537 75.7971Z"
                      fill="#F9C112"
                    />
                    <path
                      d="M54.739 12.8531L46.8509 20.7425C45.6316 21.9277 47.5203 23.8229 48.7068 22.5984L56.5949 14.7102C57.1068 14.1971 55.2522 12.3412 54.739 12.8531Z"
                      fill="#132A3A"
                    />
                    <path
                      d="M66.7275 8.52321C66.7287 8.10644 66.6471 7.69358 66.4876 7.30855C66.3281 6.92352 66.0938 6.57396 65.7982 6.28015L63.1693 3.65121C62.5651 3.07403 61.7617 2.75195 60.9262 2.75195C60.0907 2.75195 59.2873 3.07403 58.6831 3.65121L56.2143 6.12002C55.1105 6.00027 53.9941 6.14626 52.9582 6.54582C51.9223 6.94539 50.997 7.58693 50.2595 8.4169C50.0226 8.66486 49.8922 8.99569 49.8961 9.33861C49.9 9.68154 50.038 10.0093 50.2805 10.2518L59.1976 19.1689C59.446 19.4146 59.7816 19.5518 60.1309 19.5506C60.4802 19.5494 60.8148 19.4097 61.0614 19.1623C61.8329 18.4156 62.4274 17.5055 62.801 16.4988C63.1746 15.4922 63.3179 14.4146 63.2205 13.3453L65.7982 10.7663C66.0939 10.4723 66.3284 10.1225 66.4879 9.73726C66.6474 9.35199 66.7288 8.93888 66.7275 8.5219V8.52321Z"
                      fill="#276E91"
                    />
                    <path
                      d="M26.2433 38.9837C25.9148 38.9757 25.6013 38.8449 25.3643 38.6172C25.1274 38.3894 24.9844 38.0813 24.9633 37.7533C24.9422 37.4254 25.0447 37.1015 25.2505 36.8453C25.4563 36.5891 25.7506 36.4193 26.0753 36.3692L69.0256 30.7754C69.3709 30.7303 69.72 30.8242 69.996 31.0365C70.2721 31.2488 70.4525 31.5621 70.4976 31.9074C70.5426 32.2527 70.4487 32.6018 70.2364 32.8778C70.0241 33.1539 69.7108 33.3343 69.3655 33.3794L26.4153 38.9732C26.3587 38.9805 26.3004 38.984 26.2433 38.9837ZM31.5655 29.0258C31.237 29.0177 30.9234 28.8869 30.6865 28.6592C30.4496 28.4315 30.3065 28.1233 30.2855 27.7954C30.2644 27.4675 30.3669 27.1435 30.5727 26.8874C30.7785 26.6312 31.0728 26.4614 31.3975 26.4113L61.3317 22.5132C61.6738 22.4745 62.0173 22.5719 62.2884 22.7841C62.5594 22.9964 62.7361 23.3067 62.7805 23.648C62.8249 23.9894 62.7335 24.3346 62.5258 24.6091C62.3181 24.8837 62.0109 25.0657 61.6703 25.1159L31.7362 29.014C31.6796 29.0218 31.6226 29.0257 31.5655 29.0258ZM27.4312 48.0951C27.1026 48.087 26.7891 47.9563 26.5522 47.7285C26.3152 47.5008 26.1722 47.1927 26.1511 46.8647C26.13 46.5368 26.2325 46.2128 26.4383 45.9567C26.6441 45.7005 26.9384 45.5307 27.2632 45.4806L70.2121 39.8867C70.555 39.8463 70.8999 39.9426 71.1723 40.1548C71.4447 40.367 71.6225 40.6779 71.6672 41.0202C71.7119 41.3626 71.6199 41.7087 71.4112 41.9837C71.2025 42.2587 70.8938 42.4404 70.552 42.4894L27.6018 48.0833C27.5452 48.091 27.4882 48.0949 27.4312 48.0951ZM28.6177 57.2052C28.2891 57.1971 27.9756 57.0663 27.7387 56.8386C27.5017 56.6109 27.3587 56.3027 27.3376 55.9748C27.3165 55.6469 27.419 55.3229 27.6248 55.0667C27.8306 54.8106 28.1249 54.6407 28.4497 54.5907L71.3986 48.9968C71.7415 48.9564 72.0864 49.0527 72.3588 49.2649C72.6312 49.477 72.809 49.788 72.8537 50.1303C72.8984 50.4726 72.8064 50.8188 72.5977 51.0938C72.389 51.3688 72.0803 51.5505 71.7385 51.5995L28.7896 57.1947C28.7326 57.2019 28.6751 57.2055 28.6177 57.2052ZM29.8028 66.3152C29.4757 66.3051 29.1641 66.1734 28.9289 65.9458C28.6937 65.7182 28.5518 65.4111 28.531 65.0845C28.5101 64.7578 28.6118 64.4352 28.8162 64.1795C29.0206 63.9239 29.3129 63.7536 29.6362 63.7021L42.6522 62.0063C42.8232 61.9842 42.9969 61.9959 43.1633 62.0409C43.3297 62.0858 43.4857 62.1632 43.6223 62.2684C43.7588 62.3736 43.8733 62.5047 43.9592 62.6542C44.0451 62.8037 44.1007 62.9687 44.1229 63.1396C44.145 63.3106 44.1333 63.4843 44.0883 63.6507C44.0433 63.8172 43.966 63.9731 43.8608 64.1097C43.7555 64.2463 43.6244 64.3608 43.4749 64.4467C43.3255 64.5325 43.1605 64.5882 42.9895 64.6103C42.7559 64.6287 30.0168 66.3218 29.8042 66.3165L29.8028 66.3152Z"
                      fill="#FFA000"
                    />
                  </svg>
                </div>
                <h5>Job that fits you</h5>
                <p>
                  Find local caregiver job opportunities to fit you and your
                  schedule.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 ">
              <div className="caregiver-feature-card text-center">
                <div className="caregiver-icon-box">
                  <svg
                    width="84"
                    height="84"
                    viewBox="0 0 84 84"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M1.75 42H12.25V71.75H1.75V42Z" fill="#276E91" />
                    <path
                      d="M12.25 42C12.25 69.5625 12.075 68.25 12.25 68.25C10.3935 68.25 8.61301 67.5125 7.30025 66.1997C5.9875 64.887 5.25 63.1065 5.25 61.25V42H12.25Z"
                      fill="#276E91"
                    />
                    <path
                      d="M82.25 55.9998C82.2503 56.9656 81.9843 57.9129 81.481 58.7373C80.9777 59.5616 80.2568 60.2312 79.3975 60.6723C48.545 76.4398 49.1925 76.9998 42.2975 76.9998C37.2925 76.9998 35.2975 75.5473 21.2975 69.1948C18.725 68.0048 16.94 68.2498 12.25 68.2498V45.4998C28.9275 43.4173 23.6075 42.5773 49.49 54.7398C50.3142 55.1294 51.0227 55.727 51.5458 56.4736C52.0689 57.2202 52.3885 58.0902 52.4733 58.9979C52.5581 59.9056 52.405 60.8197 52.0292 61.6503C51.6534 62.4809 51.0678 63.1993 50.33 63.7348L74.6025 51.3273C75.403 50.9164 76.2956 50.7181 77.1948 50.7515C78.0939 50.7849 78.9694 51.0488 79.7372 51.5179C80.505 51.987 81.1393 52.6456 81.5794 53.4304C82.0194 54.2153 82.2503 55.1 82.25 55.9998Z"
                      fill="#F6CCAF"
                    />
                    <path
                      d="M81.935 54.2503C81.0075 56.9628 81.375 56.1578 51.2225 71.5753C48.4644 72.9791 45.389 73.6424 42.2975 73.5003C37.2925 73.5003 35.2975 72.0478 21.2975 65.6953C20.1047 65.1378 18.815 64.8169 17.5 64.7503C17.0359 64.7503 16.5908 64.5659 16.2626 64.2377C15.9344 63.9095 15.75 63.4644 15.75 63.0003V45.0628C28.2975 43.5053 24.745 43.1203 49.49 54.7403C50.1794 55.0679 50.7891 55.542 51.2766 56.1294C51.7641 56.7168 52.1176 57.4034 52.3125 58.1415C52.5074 58.8795 52.5391 59.6511 52.4052 60.4027C52.2714 61.1542 51.9753 61.8674 51.5375 62.4928C50.75 63.7353 49.1225 64.3653 51.8875 62.9303C76.195 50.5228 74.6375 51.2578 75.25 51.0653C76.559 50.605 77.997 50.6816 79.2497 51.2785C80.5023 51.8753 81.4678 52.9437 81.935 54.2503Z"
                      fill="#FFDEC7"
                    />
                    <path
                      d="M44.2575 65.8173L30.45 59.3248C30.0654 59.1061 29.7779 58.7497 29.6455 58.3275C29.513 57.9053 29.5455 57.4486 29.7362 57.0493C29.927 56.65 30.2619 56.3378 30.6736 56.1756C31.0853 56.0133 31.5431 56.0131 31.955 56.1748L45.7625 62.6673C48.72 64.0498 49.77 60.7248 51.5375 62.4923C50.75 63.7348 49.1225 64.3648 51.8875 62.9298C53.2525 65.5898 47.705 67.4798 44.2575 65.8173Z"
                      fill="#EDB996"
                    />
                    <path d="M26.25 7H78.75V35H26.25V7Z" fill="#45B14A" />
                    <path
                      d="M78.75 7V31.5H35C33.7287 31.5131 32.4958 31.0645 31.5303 30.2373C30.5647 29.4102 29.9322 28.2608 29.75 27.0025V7H78.75Z"
                      fill="#45B14A"
                    />
                    <path
                      d="M59.5 21.0001C59.5026 22.2595 59.1654 23.4962 58.524 24.58C57.8825 25.6638 56.9605 26.5545 55.8552 27.1581C54.7499 27.7618 53.5022 28.0561 52.2437 28.01C50.9851 27.9638 49.7623 27.579 48.7042 26.8961C47.646 26.2132 46.7917 25.2574 46.2313 24.1296C45.6708 23.0018 45.4251 21.7436 45.5199 20.4878C45.6146 19.232 46.0465 18.025 46.7698 16.994C47.4932 15.9631 48.4813 15.1464 49.63 14.6301C50.6949 14.1514 51.8626 13.9466 53.0269 14.0345C54.1911 14.1224 55.3149 14.5001 56.2958 15.1332C57.2768 15.7663 58.0839 16.6347 58.6435 17.6594C59.2031 18.6841 59.4976 19.8325 59.5 21.0001Z"
                      fill="#56D95C"
                    />
                    <path
                      d="M58.87 23.87C57.5769 24.4448 56.1401 24.6143 54.7488 24.356C53.3575 24.0977 52.0772 23.4239 51.0766 22.4233C50.076 21.4227 49.4022 20.1424 49.1439 18.7511C48.8857 17.3599 49.0551 15.923 49.63 14.63C50.923 14.0551 52.3599 13.8857 53.7511 14.1439C55.1424 14.4022 56.4227 15.076 57.4233 16.0766C58.4239 17.0772 59.0977 18.3575 59.356 19.7488C59.6143 21.1401 59.4448 22.577 58.87 23.87Z"
                      fill="#56D95C"
                    />
                    <path
                      d="M35 7C35 9.32064 34.0781 11.5462 32.4372 13.1872C30.7962 14.8281 28.5706 15.75 26.25 15.75V12.25C27.6424 12.25 28.9777 11.6969 29.9623 10.7123C30.9469 9.72774 31.5 8.39239 31.5 7H35Z"
                      fill="#56D95C"
                    />
                    <path
                      d="M78.75 12.25V15.75C76.4294 15.75 74.2038 14.8281 72.5628 13.1872C70.9219 11.5462 70 9.32064 70 7H73.5C73.5 8.39239 74.0531 9.72774 75.0377 10.7123C76.0223 11.6969 77.3576 12.25 78.75 12.25Z"
                      fill="#56D95C"
                    />
                    <path
                      d="M35 35H31.5C31.5 33.6076 30.9469 32.2723 29.9623 31.2877C28.9777 30.3031 27.6424 29.75 26.25 29.75V26.25C28.5706 26.25 30.7962 27.1719 32.4372 28.8128C34.0781 30.4538 35 32.6794 35 35ZM78.75 26.25V29.75C77.3576 29.75 76.0223 30.3031 75.0377 31.2877C74.0531 32.2723 73.5 33.6076 73.5 35H70C70 32.6794 70.9219 30.4538 72.5628 28.8128C74.2038 27.1719 76.4294 26.25 78.75 26.25ZM36.75 22.75C36.2859 22.75 35.8408 22.5656 35.5126 22.2374C35.1844 21.9092 35 21.4641 35 21C35 20.6539 35.1026 20.3155 35.2949 20.0278C35.4872 19.74 35.7605 19.5157 36.0803 19.3832C36.4001 19.2508 36.7519 19.2161 37.0914 19.2836C37.4309 19.3512 37.7427 19.5178 37.9874 19.7626C38.2322 20.0073 38.3989 20.3191 38.4664 20.6586C38.5339 20.9981 38.4992 21.3499 38.3668 21.6697C38.2343 21.9895 38.01 22.2628 37.7222 22.4551C37.4345 22.6474 37.0961 22.75 36.75 22.75ZM68.25 22.75C67.963 22.7483 67.6807 22.6761 67.4282 22.5396C67.1756 22.4031 66.9606 22.2066 66.8019 21.9674C66.6432 21.7282 66.5458 21.4537 66.5183 21.1679C66.4907 20.8822 66.5339 20.5941 66.644 20.329C66.754 20.0639 66.9276 19.8299 67.1495 19.6477C67.3713 19.4655 67.6345 19.3407 67.916 19.2842C68.1974 19.2278 68.4884 19.2414 68.7633 19.3239C69.0383 19.4065 69.2887 19.5554 69.4925 19.7575C69.7393 20.0023 69.9076 20.315 69.976 20.6558C70.0444 20.9966 70.0097 21.3501 69.8764 21.6711C69.7431 21.9921 69.5172 22.2662 69.2276 22.4583C68.9379 22.6505 68.5976 22.752 68.25 22.75Z"
                      fill="#56D95C"
                    />
                    <path
                      d="M78.75 26.25V29.75C78.0131 29.7515 77.2848 29.9081 76.6125 30.2096C75.9401 30.5111 75.3387 30.9508 74.8475 31.5H70.7175C71.3994 29.9376 72.5229 28.6083 73.9499 27.6757C75.3769 26.743 77.0452 26.2475 78.75 26.25ZM34.2475 31.5C33.109 31.3457 32.0525 30.8223 31.2401 30.0099C30.4277 29.1975 29.9043 28.141 29.75 27.0025C31.7497 27.8998 33.3502 29.5003 34.2475 31.5ZM35 7C35.0025 8.70476 34.507 10.3731 33.5743 11.8001C32.6417 13.2271 31.3124 14.3506 29.75 15.0325V10.9025C30.2992 10.4113 30.7389 9.80989 31.0404 9.13753C31.3419 8.46517 31.4985 7.73687 31.5 7H35Z"
                      fill="#56D95C"
                    />
                  </svg>
                </div>
                <h5>Take control of your earnings</h5>
                <p>
                  Set your own rate and get your profile in front of families
                  actively looking for caregiver jobs in Georgia, GA.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="caregiver-feature-card text-center">
                <div className="caregiver-icon-box">
                  <svg
                    width="84"
                    height="84"
                    viewBox="0 0 84 84"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_4597_13742)">
                      <path
                        d="M66.5173 36.2783C66.5321 36.2827 66.5459 36.2902 66.5576 36.3003C66.5693 36.3104 66.5787 36.3229 66.5853 36.3369C66.5918 36.3509 66.5953 36.3662 66.5955 36.3816C66.5958 36.3971 66.5927 36.4124 66.5866 36.4266C66.1595 37.4382 62.7967 45.0261 56.8928 47.7839C49.56 51.2088 46.5194 45.7094 46.5194 45.7094C46.5194 45.7094 44.2535 39.8483 51.5863 36.4232C57.4904 33.6655 65.4675 35.9566 66.5173 36.2783Z"
                        fill="#45B14A"
                      />
                      <path
                        d="M56.8928 47.7837C62.7969 45.026 66.1597 37.4381 66.5865 36.4266C66.5927 36.4124 66.5957 36.3971 66.5955 36.3816C66.5953 36.3662 66.5918 36.3509 66.5853 36.3369C66.5787 36.3229 66.5693 36.3104 66.5576 36.3003C66.5459 36.2902 66.5321 36.2827 66.5173 36.2783L46.5194 45.7093C46.5196 45.7094 49.56 51.2088 56.8928 47.7837Z"
                        fill="#45B14A"
                      />
                      <path
                        d="M17.4826 36.2783C17.4678 36.2827 17.4541 36.2902 17.4424 36.3003C17.4307 36.3104 17.4212 36.3229 17.4147 36.3369C17.4081 36.3509 17.4047 36.3662 17.4044 36.3816C17.4042 36.3971 17.4073 36.4124 17.4134 36.4266C17.8405 37.4382 21.2032 45.0261 27.1072 47.7839C34.44 51.2088 37.4805 45.7094 37.4805 45.7094C37.4805 45.7094 39.7464 39.8483 32.4136 36.4232C26.5095 33.6655 18.5325 35.9566 17.4826 36.2783Z"
                        fill="#45B14A"
                      />
                      <path
                        d="M27.1073 47.7838C34.44 51.2089 37.4806 45.7093 37.4806 45.7093L17.4185 36.332C17.4106 36.3464 17.406 36.3624 17.4052 36.3788C17.4043 36.3952 17.4072 36.4116 17.4136 36.4267C17.8403 37.4383 21.2031 45.026 27.1073 47.7838Z"
                        fill="#45B14A"
                      />
                      <path
                        d="M43.2675 45.8493V21.4365C43.2675 21.1003 43.134 20.7779 42.8963 20.5402C42.6586 20.3025 42.3362 20.1689 42 20.1689C41.6638 20.1689 41.3414 20.3025 41.1037 20.5402C40.866 20.7779 40.7324 21.1003 40.7324 21.4365V45.8492C35.6918 43.6386 17.7027 35.7933 17.4479 36.3386C17.1831 36.9056 36.612 46.5531 40.7324 48.591V58.4921C40.7324 58.8283 40.866 59.1507 41.1037 59.3884C41.3414 59.6261 41.6638 59.7597 42 59.7597C42.3362 59.7597 42.6586 59.6261 42.8963 59.3884C43.134 59.1507 43.2675 58.8283 43.2675 58.4921V48.591C47.3878 46.5531 66.8169 36.9058 66.5521 36.3386C66.2975 35.7934 48.3082 43.6387 43.2675 45.8493Z"
                        fill="#45B14A"
                      />
                      <path
                        d="M45.6487 4.23757C45.6487 7.5267 44.0151 13.705 41.9999 13.705C39.9848 13.705 38.3512 7.52653 38.3512 4.23757C38.3512 0.948609 39.9848 0 41.9999 0C44.0151 0 45.6487 0.948609 45.6487 4.23757ZM45.6487 28.83C45.6487 25.5409 44.0151 19.3627 41.9999 19.3627C39.9848 19.3627 38.3512 25.5411 38.3512 28.83C38.3512 32.119 39.9848 33.0676 41.9999 33.0676C44.0151 33.0676 45.6487 32.1192 45.6487 28.83Z"
                        fill="#276E91"
                      />
                      <path
                        d="M53.2748 10.4194C50.9491 12.7452 45.4253 15.9588 44.0004 14.5338C42.5755 13.1087 45.7892 7.58492 48.1147 5.25933C50.4405 2.93358 52.2663 3.41806 53.6912 4.84294C55.1161 6.26782 55.6004 8.09367 53.2748 10.4194ZM35.8854 27.8089C38.2111 25.4832 41.4248 19.9593 39.9997 18.5344C38.5748 17.1096 33.0509 20.3232 30.7253 22.6488C28.3995 24.9746 28.884 26.8004 30.3089 28.2253C31.7338 29.6502 33.5596 30.1347 35.8854 27.8089Z"
                        fill="#276E91"
                      />
                      <path
                        d="M54.2962 20.1823C51.0071 20.1823 44.8288 18.5487 44.8288 16.5335C44.8288 14.5183 51.0072 12.8848 54.2962 12.8848C57.5851 12.8848 58.5338 14.5183 58.5338 16.5335C58.5338 18.5487 57.5853 20.1823 54.2962 20.1823ZM29.7039 20.1823C32.993 20.1823 39.1713 18.5487 39.1713 16.5335C39.1713 14.5183 32.9928 12.8848 29.7039 12.8848C26.4149 12.8848 25.4663 14.5183 25.4663 16.5335C25.4663 18.5487 26.4148 20.1823 29.7039 20.1823Z"
                        fill="#276E91"
                      />
                      <path
                        d="M48.1146 27.8088C45.7888 25.4831 42.5752 19.9593 44.0002 18.5344C45.4253 17.1095 50.9491 20.3232 53.2747 22.6487C55.6004 24.9745 55.1159 26.8003 53.6911 28.2252C52.2662 29.6501 50.4403 30.1346 48.1146 27.8088ZM30.7251 10.4194C33.0508 12.7451 38.5747 15.9588 39.9995 14.5337C41.4244 13.1088 38.2108 7.58485 35.8852 5.25927C33.5596 2.93368 31.7336 3.41799 30.3087 4.84288C28.8838 6.26776 28.3995 8.09361 30.7251 10.4194Z"
                        fill="#276E91"
                      />
                      <path
                        d="M41.9999 20.8841C44.4023 20.8841 46.3497 18.9367 46.3497 16.5344C46.3497 14.132 44.4023 12.1846 41.9999 12.1846C39.5976 12.1846 37.6501 14.132 37.6501 16.5344C37.6501 18.9367 39.5976 20.8841 41.9999 20.8841Z"
                        fill="#FEC37D"
                      />
                      <path
                        d="M51.5819 84.0002H32.4181C32.0358 84.0002 31.6652 83.8679 31.3693 83.6258C31.0734 83.3836 30.8704 83.0466 30.7947 82.6718L25.7177 57.5195H58.2823L53.2052 82.6718C53.1296 83.0466 52.9266 83.3836 52.6307 83.6258C52.3348 83.8679 51.9643 84.0002 51.5819 84.0002Z"
                        fill="#FEC37D"
                      />
                      <path
                        d="M49.8315 57.5195L44.7544 82.6718C44.6787 83.0466 44.4757 83.3836 44.1798 83.6258C43.8839 83.8679 43.5133 84.0002 43.131 84.0002H51.5817C52.37 84.0002 53.0491 83.4445 53.2051 82.6718L58.2821 57.5195H49.8315Z"
                        fill="#F9AE5D"
                      />
                      <path
                        d="M60.7519 62.0002H23.2482C23.1344 62.0002 23.0218 61.9779 22.9167 61.9343C22.8116 61.8908 22.7161 61.827 22.6357 61.7466C22.5553 61.6662 22.4915 61.5707 22.448 61.4656C22.4044 61.3605 22.3821 61.2479 22.3821 61.1341V56.6454C22.3821 56.4157 22.4733 56.1954 22.6358 56.033C22.7982 55.8705 23.0185 55.7793 23.2482 55.7793H60.7519C60.8656 55.7793 60.9782 55.8017 61.0833 55.8452C61.1884 55.8887 61.2839 55.9525 61.3643 56.0329C61.4448 56.1133 61.5086 56.2088 61.5521 56.3139C61.5956 56.419 61.618 56.5316 61.618 56.6454V61.1341C61.618 61.2479 61.5956 61.3605 61.5521 61.4656C61.5086 61.5707 61.4448 61.6662 61.3643 61.7466C61.2839 61.827 61.1884 61.8908 61.0833 61.9343C60.9782 61.9779 60.8656 62.0002 60.7519 62.0002Z"
                        fill="#F2A559"
                      />
                      <path
                        d="M60.7518 55.7793H53.0282V62.0002H60.7518C60.8655 62.0002 60.9781 61.9779 61.0832 61.9343C61.1883 61.8908 61.2838 61.827 61.3642 61.7466C61.4447 61.6662 61.5085 61.5707 61.552 61.4656C61.5955 61.3605 61.6179 61.2479 61.6179 61.1341V56.6454C61.6179 56.4157 61.5266 56.1954 61.3642 56.033C61.2018 55.8705 60.9815 55.7793 60.7518 55.7793Z"
                        fill="#EA8F3D"
                      />
                      <path
                        d="M55.1737 72.9199L55.6854 70.3848H28.3146L28.8263 72.9199H55.1737Z"
                        fill="#F2A559"
                      />
                      <path
                        d="M46.723 72.9199H55.1737L55.3919 71.839L55.6854 70.3848H47.2347L46.723 72.9199Z"
                        fill="#EA8F3D"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4597_13742">
                        <rect width="84" height="84" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <h5>A trusted community</h5>
                <p>
                  With more than 15 years of serving millions of caregivers, you
                  can feel confident working with Care.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="caregiver-featured-jobs-section">
        <div className="container">
          <div className="job-filter-heading">
            <h2>
              Find Home Care in Atlanta, Georgia, That Matches Your Lifestyle
            </h2>
            <form className="job-filter-form">
              <div className="row g-2">
                <div className="col-md-2">
                  <div className="form-group">
                    <h4>Location</h4>
                    <select
                      id="location"
                      name="location"
                      className="form-control"
                    >
                      <option value="">Select Location</option>
                      <option>Atlanta</option>
                      <option>Savannah</option>
                      <option>Augusta</option>
                      <option>Macon</option>
                      <option>Other</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="form-group">
                    <h4>Job Type</h4>
                    <select
                      id="jobType"
                      name="jobType"
                      className="form-control"
                    >
                      <option value="">Select Job Type</option>
                      <option>Part-Time</option>
                      <option>Full-Time</option>
                      <option>Live-In</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="form-group">
                    <h4>Skills </h4>
                    <input
                      type="text"
                      id="skills"
                      name="skills"
                      className="form-control"
                      placeholder="e.g. Elder Care, Patient Care"
                    />
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="form-group">
                    <h4>Years of Experience</h4>
                    <select
                      id="experience"
                      name="experience"
                      className="form-control"
                    >
                      <option value="">Select Experience</option>
                      <option>0–1 Year</option>
                      <option>1–3 Years</option>
                      <option>3–5 Years</option>
                      <option>5+ Years</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="form-group">
                    <h4>Pay Range</h4>
                    <select
                      id="payRange"
                      name="payRange"
                      className="form-control"
                    >
                      <option value="">Select Pay Range</option>
                      <option>$10 – $15 / hr</option>
                      <option>$15 – $20 / hr</option>
                      <option>$20 – $25 / hr</option>
                      <option>$25+ / hr</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-2">
                  <div className="form-group">
                    <h4>Certification</h4>
                    <select
                      id="certification"
                      name="certification"
                      className="form-control"
                    >
                      <option value="">Select Certification</option>
                      <option>CNA</option>
                      <option>HHA</option>
                      <option>LVN</option>
                      <option>RN</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <button type="submit" class="btn-job-match">
                      Job Match
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="caregiver-featured-jobs-wrapper">
            <div className="row">
              <div className="col-lg-8">
                <div className="caregiver-featured-jobs-list">
                  <h3>In-Demand Caregiver Roles Available Across Georgia</h3>

                  <div class="caregiver-featured-card">
                    <div class="caregiver-featured-image">
                      <img src={featurejobs1} alt="Find Caregiver Jobs" />
                    </div>
                    <div class="caregiver-featured-content">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="">
                          <h5>Nursing Assistant</h5>
                          <div class="job-meta">
                            <span>Cristina</span>
                            <span>2-3 days</span>
                            <span>California </span>
                          </div>
                        </div>
                        <div class="job-action">
                          <a href="#" class="btn btn-view">
                            See details
                          </a>
                        </div>
                      </div>

                      <p>
                        We are seeking a compassionate and dedicated Nursing
                        Assistant (CNA) to provide essential patient care and
                        support under the supervision of registered nurses and
                        healthcare professionals...
                        <a href="#">read more</a>
                      </p>
                    </div>
                  </div>

                  <div class="caregiver-featured-card">
                    <div class="caregiver-featured-image">
                      <img src={featurejobs2} alt="Find Caregiver Jobs" />
                    </div>
                    <div class="caregiver-featured-content">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="">
                          <h5>Home Health Aide</h5>
                          <div class="job-meta">
                            <span>Cristina</span>
                            <span>2-3 days</span>
                            <span>California </span>
                          </div>
                        </div>
                        <div class="job-action">
                          <a href="#" class="btn btn-view">
                            See details
                          </a>
                        </div>
                      </div>

                      <p>
                        We are seeking a compassionate and reliable Home Health
                        Aide (HHA) to provide personal care and basic
                        health-related services to clients in their homes. The
                        Home Health Aide supports patients with daily
                        activities...
                        <a href="#">read more</a>
                      </p>
                    </div>
                  </div>

                  <div className="caregiver-featured-actions">
                    <a href="" className="btn-view-all">
                      Find a Job
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="howitwork-sidebar">
                  <h3>Finding Live-in Caregiver Jobs in Georgia Made Simple</h3>

                  <div className="howitwork-step-list">
                    <div className="howitwork-step" role="listitem">
                      <div className="howitwork-icon" aria-hidden="true">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M19.2101 15.741L15.67 19.281C15.53 19.421 15.4 19.681 15.37 19.871L15.18 21.221C15.11 21.711 15.45 22.051 15.94 21.981L17.29 21.791C17.48 21.761 17.75 21.631 17.88 21.491L21.42 17.951C22.03 17.341 22.32 16.631 21.42 15.731C20.53 14.841 19.8201 15.131 19.2101 15.741Z"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M18.7002 16.25C19.0002 17.33 19.8402 18.17 20.9202 18.47"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M3.41016 22C3.41016 18.13 7.26018 15 12.0002 15C13.0402 15 14.0402 15.15 14.9702 15.43"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="howitwork-step-text">
                        <h4>Step 1: Create your profile</h4>
                        <p>
                          Share your caregiving background, certifications,
                          availability, and preferred work areas so families
                          seeking <b>in-home care in Atlanta</b> and statewide
                          support can find you easily.
                        </p>
                      </div>
                    </div>

                    <div className="howitwork-step" role="listitem">
                      <div className="howitwork-icon" aria-hidden="true">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 18.1992C14.2091 18.1992 16 16.4084 16 14.1992C16 11.9901 14.2091 10.1992 12 10.1992C9.79086 10.1992 8 11.9901 8 14.1992C8 16.4084 9.79086 18.1992 12 18.1992Z"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M10.4399 14.3003L11.0899 14.9503C11.2799 15.1403 11.5899 15.1403 11.7799 14.9603L13.5599 13.3203"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M7.99983 22H15.9998C20.0198 22 20.7398 20.39 20.9498 18.43L21.6998 10.43C21.9698 7.99 21.2698 6 16.9998 6H6.99983C2.72983 6 2.02983 7.99 2.29983 10.43L3.04983 18.43C3.25983 20.39 3.97983 22 7.99983 22Z"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M8 6V5.2C8 3.43 8 2 11.2 2H12.8C16 2 16 3.43 16 5.2V6"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M21.6498 11C19.9198 12.26 17.9998 13.14 16.0098 13.64"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M2.62012 11.2695C4.29012 12.4095 6.11012 13.2195 8.00012 13.6795"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="howitwork-step-text">
                        <h4>Step 2: Get matched & apply</h4>
                        <p>
                          Explore open roles or receive personalized job invites
                          that match your skills - including
                          <b>home care in Atlanta, Georgia,</b> and live-in
                          opportunities.
                        </p>
                      </div>
                    </div>

                    <div className="howitwork-step" role="listitem">
                      <div className="howitwork-icon" aria-hidden="true">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.87988 18.1501V16.0801"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                          <path
                            d="M12 18.1498V14.0098"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                          <path
                            d="M17.1201 18.1497V11.9297"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                          <path
                            d="M17.1199 5.84961L16.6599 6.38961C14.1099 9.36961 10.6899 11.4796 6.87988 12.4296"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-linecap="round"
                          />
                          <path
                            d="M14.1899 5.84961H17.1199V8.76961"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                            stroke="#292D32"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="howitwork-step-text">
                        <h4>Step 3: Work & Build Your Reputation</h4>
                        <p>
                          Accept roles, earn consistently, and collect reviews
                          that help unlock better opportunities and long-term
                          stability.
                        </p>
                      </div>
                    </div>

                    <div className="howitwork-step-action text-center">
                      <Link className="btn-bl" to={routes.signup}>
                        Create profile for free
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="caregiver-tips-section">
        <div className="container">
          <div className="row  justify-content-center">
            <div className="col-md-12">
              <div className="caregiver-tips-text">
                <h2>How to Get Noticed in Georgia’s Caregiving Market?</h2>
                <p>
                  Families across Georgia value caregivers who are reliable,
                  communicative, and prepared. A complete profile increases your
                  visibility for roles connected to the
                  <p>GA caregiver program,</p>private care placements, and
                  long-term support needs. Small details make a big difference
                  when employers are choosing whom to trust.
                </p>

                <div className="caregiver-tips-list">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="caregiver-tips-item">
                        <span>
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                              fill="#BDFFC0"
                            />
                            <path
                              d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                              stroke="#45B14A"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>{" "}
                        Keep caregiving experience current.
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="caregiver-tips-item">
                        <span>
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                              fill="#BDFFC0"
                            />
                            <path
                              d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                              stroke="#45B14A"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>{" "}
                        Upload certifications (CNA, HHA, CPR, First Aid)
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="caregiver-tips-item">
                        <span>
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                              fill="#BDFFC0"
                            />
                            <path
                              d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                              stroke="#45B14A"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>{" "}
                        Highlight specialties (memory care, mobility support,
                        recovery care)
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="caregiver-tips-item">
                        <span>
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                              fill="#BDFFC0"
                            />
                            <path
                              d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                              stroke="#45B14A"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>{" "}
                        Clearly state availability and job preferences
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="caregiver-tips-item">
                        <span>
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.66667 13.3333C10.3333 13.3333 13.3333 10.3333 13.3333 6.66667C13.3333 3 10.3333 0 6.66667 0C3 0 0 3 0 6.66667C0 10.3333 3 13.3333 6.66667 13.3333Z"
                              fill="#BDFFC0"
                            />
                            <path
                              d="M3.83301 6.66694L5.71967 8.55361L9.49967 4.78027"
                              stroke="#45B14A"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>{" "}
                        Use a professional, friendly profile photo.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="careseekers-testi-section">
        <div className="container">
          <h2>What Georgia Caregivers Are Saying</h2>
          <div className="ro">
            <CarouselProvider
              naturalSlideWidth={100}
              naturalSlideHeight={100}
              totalSlides={3}
              visibleSlides={window.innerWidth < 768 ? 1 : 3}
              isPlaying={true}
              interval={4000}
              infinite={true}
            >
              <Slider>
                <Slide index={0}>
                  <div className="co mx-2">
                    <div className="testi-single-box h-100">
                      <div className="testi-icon">
                        <svg
                          width="54"
                          height="40"
                          viewBox="0 0 54 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M23.695 4.12089V26.7858C23.6916 30.0635 22.388 33.206 20.0704 35.5237C17.7527 37.8414 14.6102 39.145 11.3324 39.1484C10.7859 39.1484 10.2619 38.9313 9.87547 38.5449C9.48905 38.1585 9.272 37.6344 9.272 37.088C9.272 36.5415 9.48905 36.0174 9.87547 35.631C10.2619 35.2446 10.7859 35.0275 11.3324 35.0275C13.5183 35.0275 15.6146 34.1592 17.1602 32.6135C18.7058 31.0679 19.5742 28.9716 19.5742 26.7858V24.7253H4.12088C3.02796 24.7253 1.97979 24.2912 1.20698 23.5183C0.434163 22.7455 0 21.6974 0 20.6045V4.12089C0 3.02796 0.434163 1.9798 1.20698 1.20698C1.97979 0.434162 3.02796 0 4.12088 0H19.5742C20.6671 0 21.7153 0.434162 22.4881 1.20698C23.2609 1.9798 23.695 3.02796 23.695 4.12089ZM49.4505 0H33.9973C32.9043 0 31.8562 0.434162 31.0833 1.20698C30.3105 1.9798 29.8764 3.02796 29.8764 4.12089V20.6045C29.8764 21.6974 30.3105 22.7455 31.0833 23.5183C31.8562 24.2912 32.9043 24.7253 33.9973 24.7253H49.4505V26.7858C49.4505 28.9716 48.5824 31.0679 47.0365 32.6135C45.491 34.1592 43.3946 35.0275 41.2088 35.0275C40.6623 35.0275 40.1382 35.2446 39.7518 35.631C39.3655 36.0174 39.1484 36.5415 39.1484 37.088C39.1484 37.6344 39.3655 38.1585 39.7518 38.5449C40.1382 38.9313 40.6623 39.1484 41.2088 39.1484C44.4866 39.145 47.629 37.8414 49.9468 35.5237C52.2646 33.206 53.5679 30.0635 53.5714 26.7858V4.12089C53.5714 3.02796 53.1371 1.9798 52.3644 1.20698C51.5916 0.434162 50.5433 0 49.4505 0Z"
                            fill="#45B14A"
                          />
                        </svg>
                      </div>
                      <div className="testi-content">
                        <p className="testi-text">
                          Before joining, I struggled to find families looking
                          for long-term care. Now I’m connected with consistent
                          clients and feel secure in my caregiving career.
                        </p>
                      </div>
                    </div>
                  </div>
                </Slide>
                <Slide index={1}>
                  <div className="co mx-2">
                    <div className="testi-single-box h-100">
                      <div className="testi-icon">
                        <svg
                          width="54"
                          height="40"
                          viewBox="0 0 54 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M23.695 4.12089V26.7858C23.6916 30.0635 22.388 33.206 20.0704 35.5237C17.7527 37.8414 14.6102 39.145 11.3324 39.1484C10.7859 39.1484 10.2619 38.9313 9.87547 38.5449C9.48905 38.1585 9.272 37.6344 9.272 37.088C9.272 36.5415 9.48905 36.0174 9.87547 35.631C10.2619 35.2446 10.7859 35.0275 11.3324 35.0275C13.5183 35.0275 15.6146 34.1592 17.1602 32.6135C18.7058 31.0679 19.5742 28.9716 19.5742 26.7858V24.7253H4.12088C3.02796 24.7253 1.97979 24.2912 1.20698 23.5183C0.434163 22.7455 0 21.6974 0 20.6045V4.12089C0 3.02796 0.434163 1.9798 1.20698 1.20698C1.97979 0.434162 3.02796 0 4.12088 0H19.5742C20.6671 0 21.7153 0.434162 22.4881 1.20698C23.2609 1.9798 23.695 3.02796 23.695 4.12089ZM49.4505 0H33.9973C32.9043 0 31.8562 0.434162 31.0833 1.20698C30.3105 1.9798 29.8764 3.02796 29.8764 4.12089V20.6045C29.8764 21.6974 30.3105 22.7455 31.0833 23.5183C31.8562 24.2912 32.9043 24.7253 33.9973 24.7253H49.4505V26.7858C49.4505 28.9716 48.5824 31.0679 47.0365 32.6135C45.491 34.1592 43.3946 35.0275 41.2088 35.0275C40.6623 35.0275 40.1382 35.2446 39.7518 35.631C39.3655 36.0174 39.1484 36.5415 39.1484 37.088C39.1484 37.6344 39.3655 38.1585 39.7518 38.5449C40.1382 38.9313 40.6623 39.1484 41.2088 39.1484C44.4866 39.145 47.629 37.8414 49.9468 35.5237C52.2646 33.206 53.5679 30.0635 53.5714 26.7858V4.12089C53.5714 3.02796 53.1371 1.9798 52.3644 1.20698C51.5916 0.434162 50.5433 0 49.4505 0Z"
                            fill="#45B14A"
                          />
                        </svg>
                      </div>
                      <div className="testi-content">
                        <p className="testi-text">
                          What stood out was transparency. Job details were
                          clear, communication was smooth, and I knew exactly
                          what families expected before applying.
                        </p>
                      </div>
                    </div>
                  </div>
                </Slide>
                <Slide index={2}>
                  <div className="co mx-2">
                    <div className="testi-single-box h-100">
                      <div className="testi-icon">
                        <svg
                          width="54"
                          height="40"
                          viewBox="0 0 54 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M23.695 4.12089V26.7858C23.6916 30.0635 22.388 33.206 20.0704 35.5237C17.7527 37.8414 14.6102 39.145 11.3324 39.1484C10.7859 39.1484 10.2619 38.9313 9.87547 38.5449C9.48905 38.1585 9.272 37.6344 9.272 37.088C9.272 36.5415 9.48905 36.0174 9.87547 35.631C10.2619 35.2446 10.7859 35.0275 11.3324 35.0275C13.5183 35.0275 15.6146 34.1592 17.1602 32.6135C18.7058 31.0679 19.5742 28.9716 19.5742 26.7858V24.7253H4.12088C3.02796 24.7253 1.97979 24.2912 1.20698 23.5183C0.434163 22.7455 0 21.6974 0 20.6045V4.12089C0 3.02796 0.434163 1.9798 1.20698 1.20698C1.97979 0.434162 3.02796 0 4.12088 0H19.5742C20.6671 0 21.7153 0.434162 22.4881 1.20698C23.2609 1.9798 23.695 3.02796 23.695 4.12089ZM49.4505 0H33.9973C32.9043 0 31.8562 0.434162 31.0833 1.20698C30.3105 1.9798 29.8764 3.02796 29.8764 4.12089V20.6045C29.8764 21.6974 30.3105 22.7455 31.0833 23.5183C31.8562 24.2912 32.9043 24.7253 33.9973 24.7253H49.4505V26.7858C49.4505 28.9716 48.5824 31.0679 47.0365 32.6135C45.491 34.1592 43.3946 35.0275 41.2088 35.0275C40.6623 35.0275 40.1382 35.2446 39.7518 35.631C39.3655 36.0174 39.1484 36.5415 39.1484 37.088C39.1484 37.6344 39.3655 38.1585 39.7518 38.5449C40.1382 38.9313 40.6623 39.1484 41.2088 39.1484C44.4866 39.145 47.629 37.8414 49.9468 35.5237C52.2646 33.206 53.5679 30.0635 53.5714 26.7858V4.12089C53.5714 3.02796 53.1371 1.9798 52.3644 1.20698C51.5916 0.434162 50.5433 0 49.4505 0Z"
                            fill="#45B14A"
                          />
                        </svg>
                      </div>
                      <div className="testi-content">
                        <p className="testi-text">
                          As a caregiver in Georgia, finding the right fit
                          matters. Care-Exchange helped me connect with families
                          who genuinely value professionalism and compassion.
                        </p>
                      </div>
                    </div>
                  </div>
                </Slide>
              </Slider>
              <div className="carousel-arrows">
                <ButtonBack className="carousel-btn prev">‹</ButtonBack>
                <ButtonNext className="carousel-btn next">›</ButtonNext>
              </div>
            </CarouselProvider>
          </div>
        </div>
      </div>
      {/* ── Locations Section ── */}
      <LocationsGrid currentCode="GA" />

      <div className="faq-section">
        <div className="container">
          <div className="faq-page-heading">
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="faq-page-accordion">
            <Accordion>
              <AccordionSummary
                className="faqAccordion"
                expandIcon={<ExpandMoreIcon />}
              >
                What caregiving roles are most in demand in Georgia?
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  Senior care, live-in support, recovery assistance, and in-home
                  care roles are consistently in demand across the state.
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="faqAccordion"
                expandIcon={<ExpandMoreIcon />}
              >
                Can caregivers choose where they want to work within Georgia?
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  Caregivers can focus on specific cities or regions, such as
                  metro Atlanta or nearby suburbs, and apply only to roles that
                  fit their travel range and comfort level.
                </p>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                className="faqAccordion"
                expandIcon={<ExpandMoreIcon />}
              >
                Do Georgia caregivers get paid hourly or weekly?
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  Payment structures vary by role. Some families offer hourly
                  pay for part-time care, while live-in and long-shift roles
                  often provide weekly or fixed-rate compensation based on
                  responsibilities.
                </p>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                className="faqAccordion"
                expandIcon={<ExpandMoreIcon />}
              >
                How quickly can a caregiver start working after applying for a
                job?
              </AccordionSummary>
              <AccordionDetails>
                <p>
                  Many caregivers begin receiving responses within days,
                  especially when their profile is complete, and availability
                  aligns with family needs. Clear communication often speeds up
                  the hiring process.
                </p>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>

      <div className="post-job-section">
        <div className="container">
          <h5 className="fw-bold mb-3">
            Grow Your Caregiving Career in Georgia With Care-Exchange. Connect
            With Families and Individuals Who Value Your Work.
          </h5>

          <Link to={providerRoutes.routes.providerRegister} className="btn-gr">
            Sign Up Now
          </Link>
        </div>
      </div>

      <div className="care-provider-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="care-provider-copyright">
                <p>&copy; 2025 Care-Exchange.com. All rights reserved.</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="care-provider-copyright text-end">
                <Link className="" to={routes.about}>
                  About Us
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.contact}>
                  Contact Us
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.term}>
                  Terms and Conditions
                </Link>{" "}
                &nbsp; | &nbsp;
                <Link className="" to={routes.privacy}>
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageGeorgia;
